import { httpInterceptor } from '../http-interceptor';

export class OverheadCraneService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllOverheadCranesNew',
    SAVE_NEW: 'Machine/saveNewOverheadCrane',
    UPDATE: 'Machine/saveNewOverheadCrane',
    DELETE: 'Machine/deleteOverheadCrane',
    SAVE_MAINTENANCE: 'Machine/SaveOrUpdateOverheadCraneMaintenance',
    UPLOAD_DOCUMENT: 'Customer/Upload',
    GET_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecordsByOverheadCraneId',
    GET_MAINTENANCE_RECORD_DETAILS: 'Machine/getOverheadCraneMaintenanceRecordDetails',
    ADD_MAINTENANCE_RECORD: 'Machine/saveOverheadCraneMaintenanceAllRecords',
    GET_BY_ASSET_NUMBER: 'Machine/getAllOverheadCraneByAsstNo',
    GET_SAFETY_CHECKLIST_BY_OVERHEAD_CRANE: 'Machine/overheadCraneSafetyChecklistByOverheadCrane',
    SAVE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateOverheadCraneSafetyChecklist',
    DELETE_SAFETY_CHECKLIST: 'Machine/deleteOverheadCraneSafetyChecklist'
  };

  static async getAllOverheadCranes(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async saveNewOverheadCrane(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW, data);
  }

  static async updateOverheadCrane(data) {
    return httpInterceptor.post(this.ENDPOINTS.UPDATE, data);
  }

  static async deleteOverheadCrane(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }

  static async saveOverheadCraneMaintenance(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MAINTENANCE, data);
  }

  static async uploadDocument(data) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, data);
  }

  static async getMaintenanceRecordsByOverheadCraneId(overheadCraneId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORDS}/${overheadCraneId}`);
  }

  static async getMaintenanceRecordDetails(recordId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MAINTENANCE_RECORD_DETAILS}/${recordId}`);
  }

  static async addMaintenanceRecord(maintenanceData) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_MAINTENANCE_RECORD, maintenanceData);
  }

  static async getAllOverheadCraneByAssetNumber(assetNumber) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ASSET_NUMBER}/${assetNumber}`);
  }

  static async getOverheadCraneSafetyChecklistByOverheadCrane(overheadCraneId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_SAFETY_CHECKLIST_BY_OVERHEAD_CRANE}/${overheadCraneId}`,
    );
  }

  static async createOverheadCraneSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_SAFETY_CHECKLIST, data);
  }

  static async deleteOverheadCraneSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }
}
